var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"base-button",class:{
    altcolor: _vm.altcolor,
    secondary: _vm.isSecondary,
    small: _vm.isSmall
  },attrs:{"disabled":_vm.disabled,"type":_vm.type}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }